
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/data-catalogs",
      function () {
        return require("private-next-pages/solutions/data-catalogs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/data-catalogs"])
      });
    }
  